var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.logContext))])
}
var staticRenderFns = []

export { render, staticRenderFns }